import '@/resources/styles/preloading.scss'
import 'core-js/stable'
import 'regenerator-runtime/runtime'
import 'whatwg-fetch'

import('./app')
